<template>
  <div
      v-if="wistiaVideoId"
      class="hkkd-wistia--modal-container" 
      :id="`${ wistiaVideoId }`"
    >
      <div
        v-if="wistiaVideoId"
        class="hkkd-wistia--modal modal fade" 
        :id="`hkkd-wistia--modal-${ wistiaVideoId }`" 
        aria-hidden="true" 
        tabindex="-1"
      >
        <div
          v-if="renderComponent" 
          class="modal-dialog modal-dialog-centered modal-xl"
        >
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body hkkd-wistia--video" >

              <WistiaVideoPlayer 
                v-if="renderComponent" 
                :video-id="wistiaVideoId" 
                :auto-play="true"
                :aspect-ratio="'aspect-ratio-16-9'"
              />
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, useTemplateRef, onMounted, onUnmounted, watch, nextTick } from 'vue'
  import { useWindowSize, usePointerSwipe, useMediaQuery, onClickOutside, useTimeout } from '@vueuse/core'
  import Story from '../../models/story.model'
  import WistiaVideoPlayer from './wistia-video-player.vue'

  interface Props {
    wistiaVideoId: String
  }

  const props = defineProps<Props>()
    const emit = defineEmits<{
    (e: 'active', value: Story): void
  }>()

  const renderComponent = ref(true);

  onMounted( ()  => {
  })

  const forceRender = async () => {
    if(renderComponent?.value) {
      renderComponent.value = false;
      await nextTick();
      renderComponent.value = true;
    }
  }

  onUnmounted( () => {
  })
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $primary-font-color:  #FF9AC7;

  .modal-header {
    padding: 15px;
    border: 0;
  }

  .modal-body {
    padding: 0 20px 30px 20px;
  }

  .play-icon-none {
    position: relative;
    bottom: 50%;
    left: 50%;
    font-size: 50px;
  }

</style>